export default {
    imgPath(path) {
        if (path == undefined || path == "" || path == null) {
            return "";
        }
        return 'http://cydj.5anquan.com' + path + '?_t=123';
    },
    getNumStr(num) {
        let str = ["无", "一", "二", "三", "四", "五", "六", "七"];
        return str[num];
    },
    getLevel(num, nullStr) {
        if (nullStr == undefined) {
            nullStr = '不限';
        }
        return num < 0 ? nullStr : this.getNumStr(num) + '级';
    },
    getLevelNum(level) {
        if (level == undefined) {
            level = '';
        }
        switch (level) {
            case '一级':
                return 1;
            case '二级':
                return 2;
            case '三级':
                return 3;
            default:
                return 0;
        }
    },
    getStatus(status) {
        let str = "";
        let color = ['red', 'green', 'blue', '#ccc'];
        switch (status) {
            case 0:
                str = "未读";
                break;
            case 1:
                str = "已读";
                break;
            case 2:
                str = "收藏";
                break;
            case 3:
                str = "忽略";
                break;
            default:
                str = status;
                break;
        }
        return "<span style='color:" + color[status] + ";'>" + str + "</span>";
    },
    getZhuAnZL(num) {
        switch (num) {
            case 1:
                return "助理";
            case 2:
                return "中级";
            case 3:
                return "高级";
            default:
                return num;
        }
    },
    areaFormat(txt) {
        if (txt == undefined || txt == null || txt == 'null') {
            return '暂无信息';
        }
        //替换换行符
        return txt.replace(
            /\n/g,
            "<br>"
        );
    },
    getOrgType(type) {
        type = parseInt(type);
        switch (type) {
            case 0:
                return "应聘信息";
            case 1:
                return "副委员";
            case 2:
                return "委员";
            case 3:
                return "会员";
            case 4:
                return " "; //非会员
            default:
                return type;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/common.js
// module id = null
// module chunks = 